import apiClient from './client'

export interface QuestionOption {
  id: string
  text: string
}

export interface Question {
  question_id: string
  statement: string
  options: QuestionOption[]
  status: 'draft' | 'live' | 'archived'
  created_by: string
  created_at: string
  updated_at: string
}

export interface DetailedVote {
  user_id: string
  user_email: string
  option_id: string
  created_at: string
  updated_at: string
}

export interface VoteResults {
  question_id: string
  total_votes: number
  results: Record<string, number>
}

export interface CreateQuestionInput {
  statement: string
  options: QuestionOption[]
}

export interface UpdateQuestionInput {
  statement?: string
  options?: QuestionOption[]
}

export const questionsApi = {
  list: async (): Promise<Question[]> => {
    const response = await apiClient.get<{ questions: Question[] }>('/admin/questions')
    return response.questions
  },

  get: async (id: string): Promise<Question> => {
    return apiClient.get<Question>(`/admin/questions/${id}`)
  },

  create: async (input: CreateQuestionInput): Promise<Question> => {
    return apiClient.post<Question>('/admin/questions', input)
  },

  update: async (id: string, input: UpdateQuestionInput): Promise<Question> => {
    return apiClient.put<Question>(`/admin/questions/${id}`, input)
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/questions/${id}`)
  },

  changeStatus: async (id: string, status: string): Promise<Question> => {
    return apiClient.post<Question>(`/admin/questions/${id}/status`, { status })
  },

  getVotes: async (id: string): Promise<DetailedVote[]> => {
    const response = await apiClient.get<{ votes: DetailedVote[] }>(`/admin/questions/${id}/votes`)
    return response.votes
  },

  getResults: async (id: string): Promise<VoteResults> => {
    return apiClient.get<VoteResults>(`/admin/questions/${id}/results`)
  },
}
